/**
 * Reactstrap v9.2.3 bug workaround:
 * TooltipPopoverWrapper never passes `transition` to PopperContent,
 * but PopperContent's propTypes marks it as required. The prop is
 * filled in by defaultProps at runtime so functionality is fine —
 * this just silences the console warning.
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const PopperContent = require("reactstrap").PopperContent;

if (PopperContent?.propTypes?.transition) {
  PopperContent.propTypes.transition = () => null;
}

export {};
